"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = exports.getIsLoadingCurrentUserPermissions = exports.getHasCurrentUserPermissionsErrored = exports.getCurrentUserPermittedStatusesForNewIssue = exports.getCurrentUserPermittedStatusesForFiltering = exports.getCurrentUserPermittedActionsForNewIssue = exports.getCurrentUserPermissionLevelNumber = exports.getCurrentUserIsAdminValue = exports.getCanUserCreateIssues = exports.fetchCurrentUserPermissionsAction = exports.STATE_KEY = void 0;
var _toolkit = require("@reduxjs/toolkit");
var _sdk = require("../../../../sdk");
var _fetchHelpers = require("../fetchHelpers");
const initialState = {
  [_fetchHelpers.STATUS_KEY]: _fetchHelpers.FetchStatus.Initial
};
const currentUserPermissionsSlice = (0, _toolkit.createSlice)({
  name: "currentUserPermissions",
  initialState,
  reducers: {
    currentUserPermissionsFetchStart(state) {
      state[_fetchHelpers.STATUS_KEY] = _fetchHelpers.FetchStatus.Loading;
    },
    currentUserPermissionsFetchSuccess(state, action) {
      state[_fetchHelpers.STATUS_KEY] = _fetchHelpers.FetchStatus.Success;
      state.data = action.payload;
    },
    currentUserPermissionsFetchError(state) {
      state[_fetchHelpers.STATUS_KEY] = _fetchHelpers.FetchStatus.Error;
    }
  }
});
const {
  currentUserPermissionsFetchStart,
  currentUserPermissionsFetchSuccess,
  currentUserPermissionsFetchError
} = currentUserPermissionsSlice.actions;
const fetchCurrentUserPermissionsAction = function () {
  let {
    onSuccess
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (dispatch, getState, _ref) => {
    let {
      sdk
    } = _ref;
    dispatch(currentUserPermissionsFetchStart());
    sdk.CurrentUserPermissions.get().then(payload => {
      dispatch(currentUserPermissionsFetchSuccess(payload));
      if (onSuccess) {
        onSuccess(payload);
      }
    }).catch(e => {
      console.error(e);
      dispatch(currentUserPermissionsFetchError());
    });
  };
};
exports.fetchCurrentUserPermissionsAction = fetchCurrentUserPermissionsAction;
const reducer = exports.reducer = currentUserPermissionsSlice.reducer;
const STATE_KEY = exports.STATE_KEY = currentUserPermissionsSlice.name;
const getCurrentUserPermissionsState = state => {
  return state[STATE_KEY];
};
const getCanUserCreateIssues = exports.getCanUserCreateIssues = (0, _toolkit.createSelector)(getCurrentUserPermissionsState, state => !!state.data && state.data.permissionLevels.includes(_sdk.CurrentUserPermissionLevel.Create));
const getCurrentUserPermissionLevelNumber = exports.getCurrentUserPermissionLevelNumber = (0, _toolkit.createSelector)(getCurrentUserPermissionsState, state => {
  const permissionLevels = !!state.data ? state.data.permissionLevels : [];
  if (!!state.data && state.data.isProjectAdmin) {
    return 4;
  }
  if (permissionLevels.some(name => name === _sdk.CurrentUserPermissionLevel.Write)) {
    return 3;
  }
  if (permissionLevels.some(name => name === _sdk.CurrentUserPermissionLevel.Read)) {
    return 2;
  }
  return 1;
});
const getIsLoadingCurrentUserPermissions = exports.getIsLoadingCurrentUserPermissions = (0, _toolkit.createSelector)(getCurrentUserPermissionsState, _fetchHelpers.isLoading);
const getHasCurrentUserPermissionsErrored = exports.getHasCurrentUserPermissionsErrored = (0, _toolkit.createSelector)(getCurrentUserPermissionsState, _fetchHelpers.isErrored);

// permittedStatuses may not be defined in state.data, so we set the default to []
const getCurrentUserPermittedStatusesForNewIssue = exports.getCurrentUserPermittedStatusesForNewIssue = (0, _toolkit.createSelector)(getCurrentUserPermissionsState, state => state.data ? state.data.issues.new.permittedStatuses || [] : []);
const getCurrentUserPermittedStatusesForFiltering = exports.getCurrentUserPermittedStatusesForFiltering = (0, _toolkit.createSelector)(getCurrentUserPermissionsState, state => state.data ? state.data.issues.filter.permittedStatuses || [] : []);

// permittedActions may not be defined in state.data, so we set the default to []
const getCurrentUserPermittedActionsForNewIssue = exports.getCurrentUserPermittedActionsForNewIssue = (0, _toolkit.createSelector)(getCurrentUserPermissionsState, state => state.data ? state.data.issues.new.permittedActions || [] : []);
const getCurrentUserIsAdminValue = exports.getCurrentUserIsAdminValue = (0, _toolkit.createSelector)(getCurrentUserPermissionsState,
// return undefined when still fetching user
state => state.data && state.data.isProjectAdmin);
(0, _toolkit.createSelector)(getCurrentUserPermissionsState, state => state.data && state.data.id);
//# sourceMappingURL=currentUserPermissions.js.map